"use client";

import type { OrderBlock as OrderBlockProps } from "@/payload-types";
import { cn } from "@/utilities/ui";
import CourseForm from "../components/courseForm/CourseForm";
import { useUser } from "@/kmsApp/providers/user-provider";

export const OrderBlock: React.FC<OrderBlockProps> = ({
  title,
  subtitle,
  media,
  linksMedia,
  anchor,
}) => {
  const linkData = linksMedia?.[0]?.linkWithMedia;
  const refValue = linkData?.reference?.value;

  const { me } = useUser();

  let finalHref = "";

  if (linkData?.url) {
    finalHref = linkData.url;
  } else if (refValue && typeof refValue === "object") {
    if ("anchor" in refValue && refValue.anchor) {
      finalHref = `#${refValue.anchor}`;
    } else if ("slug" in refValue && refValue.slug) {
      finalHref = `/${refValue.slug}`;
    }
  }

  return (
    <div
      id={
        (anchor?.value &&
          typeof anchor.value === "object" &&
          anchor?.value.anchor) ||
        ""
      }
      className={cn(
        "min-h-[70vh] bg-linear-to-b from-[#567186] to-[#AFB1AB] p-5 pt-10",
      )}
    >
      <h1 className="text-center font-bold mb-6 text-white">{title}</h1>
      <CourseForm idUtilisateurDefault={me?.idContact} />
    </div>
  );
};
